<template>
	<div class="person-container">
		<div class="person-content">
			<div class="tab-container">
				<div class="cjt-tabs">
					<div class="cjt-tabs__header">
						<div class="cjt-tabs__nav-wrap">
							<div
								v-for="(tab, index) in maintenanceTabs"
								:key="index"
								class="cjt-tabs__item"
								:class="{ active: activeTabIndex === index }"
								@click="changeMaintenanceTab(index)"
							>
								<span class="cjt-tabs__item-text">{{ tab.name }}</span>
								<span v-if="tab.isHot" class="tag-member-mini tag-member--vip">HOT</span>
							</div>

							<!-- <div class="cjt-tabs-more">
									<router-link to="#">
										更多
										<i class="el-icon-arrow-right"></i>
									</router-link>
								</div> -->
						</div>
					</div>
					<div class="cjt-tabs__container">
						<transition name="fade-transform" mode="out-in">
							<div :key="activeTabIndex" class="cjt-tabs__content">
								<!-- 临期提醒内容 -->
								<div v-if="activeTabIndex === 0" class="qualificationQuery-search">
									<el-form ref="normalSearchForm" :model="normalSearchForm" label-width="150px" class="searchForm">
										<el-form-item label="姓名或证件号码" prop="nameOrIdCard">
											<el-input v-model="normalSearchForm.nameOrIdCard" placeholder="请输入姓名或证件号码"></el-input>
										</el-form-item>
										<el-form-item label="所在单位名称" prop="companyName">
											<el-input v-model="normalSearchForm.companyName" placeholder="请输入所在单位名称"></el-input>
										</el-form-item>
									</el-form>
									<div class="search-button-box">
										<el-button class="search" @click="handleSearch">查询</el-button>
										<el-button class="reset" @click="handleResetSearch">重置</el-button>
									</div>
								</div>
								<div v-if="activeTabIndex === 1" class="qualificationQuery-search">
									<el-form ref="searchForm" :model="searchForm" label-width="150px" class="searchForm">
										<el-form-item label="姓名或证件号码" prop="nameOrIdCard">
											<el-input v-model="searchForm.nameOrIdCard" placeholder="请输入姓名或证件号码"></el-input>
										</el-form-item>
										<el-form-item label="所在单位名称" prop="companyName">
											<el-input v-model="searchForm.companyName" placeholder="请输入所在单位名称"></el-input>
										</el-form-item>
										<el-form-item label="有效期" prop="isValidity">
											<el-select v-model="searchForm.isValidity" placeholder="请选择有效期">
												<el-option
													v-for="item in validityOptions"
													:key="item.value"
													:label="item.label"
													:value="item.value"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="有效期" prop="name">
											<el-date-picker
												v-model="validityTimeEnd"
												type="daterange"
												range-separator="至"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</el-form-item>
										<el-form-item label="注册类别" prop="register">
											<el-select v-model="searchForm.register" multiple collapse-tags placeholder="请选择注册类别">
												<el-option
													v-for="item in registeredOptions"
													:key="item.dictCode"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="持证数量" prop="cerCount">
											<el-select v-model="searchForm.cerCount" placeholder="请选择持证数量">
												<el-option
													v-for="item in cerCountOptions"
													:key="item.value"
													:label="item.label"
													:value="item.value"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="非注册类别" prop="unRegister">
											<el-select v-model="searchForm.unRegister" multiple collapse-tags placeholder="请选择非注册类别">
												<el-option
													v-for="item in notRegisteredOptions"
													:key="item.dictCode"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="待注册类别" prop="waitRegister">
											<el-select v-model="searchForm.waitRegister" multiple collapse-tags placeholder="请选择待注册类别">
												<el-option
													v-for="item in waitRegisteredOptions"
													:key="item.dictCode"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
									</el-form>
									<div class="search-button-box">
										<el-button class="search" @click="handleSearch">查询</el-button>
										<el-button class="reset" @click="handleResetSearch">重置</el-button>
									</div>
								</div>
							</div>
						</transition>
					</div>
					<!-- 热门查询区域--start -->
					<!-- <div class="hot-query-container">
						<div class="hot-query-content">
							<div class="hot-query-list">
								<h3 class="list-title">热门查询</h3>
								<div class="query-items">
									<div class="query-item">
										<div class="icon icon-czz"></div>
										<div class="item-content">
											<h4>查资质</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cfx"></div>
										<div class="item-content">
											<h4>查风险</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cyj"></div>
										<div class="item-content">
											<h4>查业绩</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-hyxy"></div>
										<div class="item-content">
											<h4>查行业信用</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cll"></div>
										<div class="item-content">
											<h4>查履历</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-zzsy"></div>
										<div class="item-content">
											<h4>资质溯源</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<!-- 热门查询区域--end -->

					<div v-loading="loading" class="maintenance-list">
						<!-- 列表项 -->
						<template v-if="personList.length > 0">
							<!-- 展示当前有多少条数据 -->
							<div class="notification-title">
								<span class="title-text">
									共有
									<span class="data-count">{{ pageOptions.total }}</span>
									条数据
								</span>
							</div>
							<div v-for="(item, index) in personList" :key="index" class="notification-item">
								<div class="certificate-info">
									<div class="certificate-name">
										<div>
											{{ item.personName }}（{{ item.idCard }}）
											<span>{{ item.registerUnitName ? item.registerUnitName : '未知单位' }}</span>
										</div>
									</div>
									<div class="certificate-detail">
										<div class="detail-item">
											<label>注册类别：</label>
											<span class="detail-content">
												{{ item.certificateName ? item.certificateName : '--' }}
											</span>
										</div>
										<div class="detail-item">
											<label>注册专业：</label>
											<span class="detail-content">{{ item.registerProject ? item.registerProject : '--' }}</span>
										</div>
										<div class="detail-item">
											<label>证书编号：</label>
											<span class="detail-content">
												{{ item.certificateCode ? item.certificateCode : '--' }}
											</span>
										</div>
									</div>
									<div v-if="token" class="certificate-detail">
										<div class="detail-item">
											<label>注册日期：</label>
											<span class="detail-content">
												{{ item.registerTime ? item.registerTime : '--' }}
											</span>
										</div>
										<div class="detail-item">
											<label>有效期：</label>
											<span class="detail-content">{{ item.validityTime ? item.validityTime : '--' }}</span>
										</div>
										<div class="detail-item">
											<label>注册号（执业印章号）：</label>
											<span class="detail-content">{{ item.registerCode ? item.registerCode : '--' }}</span>
										</div>
									</div>
								</div>
								<div class="certificate-status">
									<span class="collect" @click="toPersonDetail(item.personId)">
										<svg-icon icon-class="view" class="icon" />
										查看
									</span>
									<span class="collect" @click="handleIsCollect(item.personId, item.isCollect)">
										<svg-icon v-if="!item.isCollect" icon-class="collect" class="icon" />
										<svg-icon v-else icon-class="collected" class="icon collected" />
										{{ item.isCollect ? '已收藏' : '收藏' }}
									</span>
									<span class="collect" @click="handleIsMonitoring(item.personId, item.isMonitoring)">
										<svg-icon v-if="item.isMonitoring" icon-class="monitored" class="icon" />
										<svg-icon v-else icon-class="monitor" class="icon" />
										{{ item.isMonitoring ? '已监控' : '监控' }}
									</span>
								</div>
							</div>
						</template>

						<!-- 数据为空 -->
						<empty-content v-else empty-text="暂无资质信息"></empty-content>
					</div>
					<!-- 分页器 -->
					<jr-pagination
						v-if="pageOptions.total > pageOptions.limit"
						:limit="pageOptions.limit"
						:page.sync="pageOptions.page"
						:total="pageOptions.total"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						@change="handlePaginationChange"
					></jr-pagination>
				</div>
			</div>
		</div>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleCancel">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>

		<!-- 登录弹窗 -->
		<jr-dialog
			:visible.sync="loginVisible"
			width="560px"
			:custom-class="'loginDialog'"
			:show-btn="false"
			@loginDone="loginVisible = false"
		>
			<template slot="content">
				<non-login></non-login>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import NonLogin from '@/components/NonLogin'
	import { mapState, mapGetters } from 'vuex'
	import { mapDictionaries } from '@/store/dictionary-helper'
	import JrPagination from '@/components/Pagination'
	import { pagePersonCertificate, pageTabAdvancedQuery } from '@/api/qualificationQuery/person'
	import { COLLECT_TYPE_STATE } from '@/enum/index'
	import { saveUserCollect, removeUserCollect, saveUserMonitoring, removeUserMonitoring } from '@/api/userCenter/index'
	import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'

	export default {
		name: 'SearchPerson',
		components: {
			JrPagination,
			JrDialog,
			PaymentDialog,
			NonLogin
		},
		// 使用会员权益前置校验mixins
		mixins: [memberBenefitCheckerMixins],
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				// 登录弹窗
				loginVisible: false,
				// 查人员Tab数据
				activeTabIndex: 0,
				maintenanceTabs: [
					{ name: '普通查询', isHot: false },
					{ name: '高级查询', isHot: true }
				],
				normalSearchForm: {
					nameOrIdCard: '', // 姓名或证件号码
					companyName: '' // 所在单位名称
				},
				searchForm: {
					nameOrIdCard: '', // 	姓名或证件号码
					companyName: '', // 所在单位名称
					isValidity: '', // 是否有效
					validityTimeStart: '', // 有效期
					validityTimeEnd: '', // 有效期
					register: [], // 注册类别
					unRegister: [], // 非注册类别
					waitRegister: [], // 待注册类别
					cerCount: '' // 持证数量
				},
				validityTimeEnd: [],
				// 有效期下拉
				validityOptions: [
					{
						value: '1',
						label: '有效'
					},
					{
						value: '2',
						label: '已过期'
					}
				],
				// 持证数量下拉
				cerCountOptions: [
					{
						value: '1',
						label: '一人一证'
					},
					{
						value: '2',
						label: '一人多证'
					}
				],
				// 已注册下拉
				registeredOptions: [],
				// 非注册下拉
				notRegisteredOptions: [],
				// 待注册下拉
				waitRegisteredOptions: [],
				// 查人员
				personList: [],
				pageOptions: {
					currentPage: 1,
					limit: 10,
					total: 0
				},

				loading: false
			}
		},
		computed: {
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			...mapState({
				token: state => state.user.token
			}),
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['registerTypeDict'])
		},
		watch: {},
		created() {},
		async mounted() {
			if (this.$route.query && this.$route.query.value) {
				if (this.token) {
					if (this.$route.query.isHight === 'true') {
						this.searchForm.nameOrIdCard = this.$route.query.value
						this.activeTabIndex = 1
					} else {
						this.normalSearchForm.nameOrIdCard = this.$route.query.value
					}
				} else {
					this.loginVisible = true
				}
			}
			await this.$store.dispatch('dictionary/getRegisterTypeDictList')

			this.$nextTick(() => {
				this.registeredOptions = this.registerTypeDict.filter(item => !item.tags || item.tags.includes('待注册'))
				this.notRegisteredOptions = this.registerTypeDict.filter(item => item.tags && item.tags.includes('非注册'))
				this.waitRegisteredOptions = this.registerTypeDict.filter(item => item.tags && item.tags.includes('待注册'))
			})

			// 判断当前没有登录的情况下,调取新的接口，并只查询10条数据
			if (!this.token) {
				this.initNoLoginPersonList()
			} else {
				if (this.$route.query.isHight === 'true') {
					this.initAdvancedPersonList()
				} else {
					this.initPersonList()
				}
			}
		},
		methods: {
			// 判断用户是否登录
			async handleSearch() {
				if (!this.token) {
					this.loginVisible = true
					return
				}

				if (this.activeTabIndex === 1) {
					const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.GJCX_FILER)
					if (!isValid) {
						this.payVisible = true
						return
					}
				}
				if (this.activeTabIndex === 0) {
					this.initPersonList()
				} else {
					this.initAdvancedPersonList()
				}
			},
			initPersonList() {
				// 初始化人员列表数据
				this.loading = true
				const params = {
					page: this.pageOptions.currentPage,
					limit: this.pageOptions.limit,
					// registerType: '1',
					...this.normalSearchForm
				}
				pagePersonCertificate(params)
					.then(res => {
						this.personList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			initNoLoginPersonList() {
				// 初始化人员列表数据
				this.loading = true
				const params = {
					page: 1,
					limit: 10,
					registerType: '1'
				}
				pagePersonCertificate(params)
					.then(res => {
						this.personList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			initAdvancedPersonList() {
				this.loading = true
				if (this.validityTimeEnd.length > 0) {
					this.searchForm.validityTimeStart = this.validityTimeEnd[0]
					this.searchForm.validityTimeEnd = this.validityTimeEnd[1]
				}

				const params = {
					page: this.pageOptions.currentPage,
					limit: this.pageOptions.limit,
					nameOrIdCard: this.searchForm.nameOrIdCard,
					companyName: this.searchForm.companyName,
					isValidity: this.searchForm.isValidity,
					validityTimeStart: this.searchForm.validityTimeStart,
					validityTimeEnd: this.searchForm.validityTimeEnd,
					cerCount: this.searchForm.cerCount,
					register: this.searchForm.register.join(','), // 只在查询参数中转换
					unRegister: this.searchForm.unRegister.join(','),
					waitRegister: this.searchForm.waitRegister.join(',')
				}
				pageTabAdvancedQuery(params)
					.then(res => {
						this.personList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			handleResetSearch() {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (this.activeTabIndex === 1) {
					this.validityTimeEnd = []
					this.searchForm = {
						nameOrIdCard: '', // 	姓名或证件号码
						companyName: '', // 所在单位名称
						isValidity: '', // 是否有效
						validityTimeStart: '', // 有效期
						validityTimeEnd: '', // 有效期
						register: [], // 注册类别
						unRegister: [], // 非注册类别
						waitRegister: [], // 待注册类别
						cerCount: '' // 持证数量
					}
				} else {
					this.normalSearchForm = {
						nameOrIdCard: '',
						companyName: ''
					}
				}
				this.initPersonList()
			},
			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
			},
			// 分页
			handlePaginationChange(pager) {
				if (!this.token) {
					this.pageOptions.page = 1
					this.loginVisible = true
					return
				}
				const { page, limit } = pager
				this.pageOptions.currentPage = page
				this.pageOptions.limit = limit
				if (this.activeTabIndex === 1) {
					this.initAdvancedPersonList()
				} else {
					this.initPersonList()
				}
			},
			// 跳转详情
			toPersonDetail(id) {
				if (!this.token) {
					this.loginVisible = true
					return
				} else {
					const routeData = this.$router.resolve({
						path: '/qualification-query/personDetail',
						query: {
							id: id
						}
					})
					window.open(routeData.href, '_blank')
				}
			},
			// 收藏与取消收藏
			handleIsCollect(id, flag) {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (flag) {
					this.handleRemoveCollect(id)
				} else {
					this.handleCollect(id)
				}
			},
			handleCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PERSON
				}
				saveUserCollect(params).then(res => {
					this.$message.success('收藏成功')
					if (this.activeTabIndex === 1) {
						this.initAdvancedPersonList()
					} else {
						this.initPersonList()
					}
				})
			},
			handleRemoveCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PERSON
				}
				removeUserCollect(params).then(res => {
					this.$message.success('已取消收藏')
					if (this.activeTabIndex === 1) {
						this.initAdvancedPersonList()
					} else {
						this.initPersonList()
					}
				})
			},
			// 监控与取消监控
			handleIsMonitoring(id, flag) {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (flag) {
					this.handleRemoveMonitor(id)
				} else {
					this.handleMonitor(id)
				}
			},
			handleMonitor(id) {
				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.PERSON
				}
				saveUserMonitoring(params).then(response => {
					const { code, message } = response

					if (code !== 200) {
						// 这里主要处理以6开头的状态码信息，校验会员等级、会员权益等
						this.$modal.msgWarning(message)
					} else {
						this.$modal.msgSuccess('监控成功')
						if (this.activeTabIndex === 1) {
							this.initAdvancedPersonList()
						} else {
							this.initPersonList()
						}
					}
				})
			},
			handleRemoveMonitor(id) {
				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.PERSON
				}
				removeUserMonitoring(params).then(response => {
					const { code, message } = response

					if (code !== 200) {
						// 这里主要处理以6开头的状态码信息，校验会员等级、会员权益等
						this.$modal.msgWarning(message)
					} else {
						this.$modal.msgSuccess('已取消监控')
						if (this.activeTabIndex === 1) {
							this.initAdvancedPersonList()
						} else {
							this.initPersonList()
						}
					}
				})
			},
			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleCancel() {
				this.payVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.person-container {
		background-color: #eff6f9;
		.person-content {
			padding-top: 31px;
			.cjt-tabs__header {
				width: $main-page-width;
				margin: 0 auto;
				border-bottom: none;
				margin-bottom: 14px;
				.cjt-tabs__item {
					padding-bottom: 14px;
					position: relative;
					.cjt-tabs__item-text {
						font-size: 20px;
						color: #333333;
					}
					.tag-member-mini {
						height: 18px;
						line-height: 18px;
						position: absolute;
						right: -51px;
						top: -10px;
						padding: 0px 7px;
					}
				}
				.active {
					.cjt-tabs__item-text {
						color: #2671cb;
					}
					&::after {
						width: 40px;
					}
				}
			}
			.cjt-tabs__container {
				min-height: auto;
			}
			.hot-query-container {
				height: auto;
				background: none;
				.list-title {
					color: #333;
				}
				.hot-query-content {
					padding-top: 30px;
					background: #fff;
					padding-bottom: 30px;
					.query-items {
						padding-left: 20px;
						padding-right: 10px;
					}
					.list-title {
						padding-left: 20px;
					}
				}
			}
			.qualificationQuery-search {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
			}
			.maintenance-list {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
				background-color: #ffffff;
				// box-shadow: 2px 7px 21px 0px rgba(57, 127, 212, 0.17);
				border-radius: 6px;
				border-top-left-radius: 0px;
				border-top-right-radius: 0px;
				margin-top: 20px;
				.notification-title {
					background-color: #f5f7fa;
					// border-bottom: 1px solid #ebeef5;
					padding: 12px 20px;
					margin-bottom: 8px;
					border-radius: 4px 4px 0 0;

					.title-text {
						color: #606266;
						font-size: 16px;
						font-weight: 500;

						.data-count {
							color: #409eff;
							font-size: 18px;
							font-weight: 600;
							margin: 0 4px;
						}
					}
				}
				.notification-item {
					justify-content: space-between;
				}
				.certificate-info {
					flex: 0 0 834px;
					.certificate-name {
						span {
							margin-left: 10px;
						}
					}
					.detail-item {
						margin-right: 15px;
						label {
							flex: none;
						}
						.detail-content {
							padding-right: 0px;
						}
					}

					.detail-item:nth-child(1) {
						flex: 0 0 269px;
					}
					.detail-item:nth-child(2) {
						flex: 0 0 381px;
					}
				}
				.certificate-status {
					flex-direction: row;
					span {
						width: 100px;
						height: 36px;
						background-color: #ffffff;
						border-radius: 18px;
						border: solid 1px #236fca;
						text-align: center;
						color: #236fca;
						font-size: 16px;
						margin-left: 10px;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;
						&:hover {
							color: #fff;
							background-color: #236fca;
							.icon {
								color: #fff !important;
							}
						}
					}
					.collect {
						.icon {
							margin-right: 5px;
							font-size: 18px;
						}
						.collected {
							color: #236fca;
						}
						&:hover {
							.icon {
								color: #236fca;
							}
						}
					}
				}
			}
			.hot-query-container {
				height: 290px;
			}
		}
		.certificate-info {
			flex: 0 0 900px !important;
			.certificate-detail {
				justify-content: normal;
				align-items: flex-start;
				margin-bottom: 5px;
				.detail-item {
					&:nth-child(1) {
						flex: 0 0 200px !important;
					}
					&:nth-child(2) {
						flex: 0 0 180px !important;
					}
					&:nth-child(3) {
						flex: 0 0 300px !important;
					}
				}
			}
		}
	}
</style>
